import { Accordion, AccordionSummary, AccordionDetails, AccordionActions, Grid, Button } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useNavigate, createSearchParams, useSearchParams } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { DateInput } from 'qubCommon/Inputs';
import { useTranslation } from 'react-i18next';
import { IconShoppingCartDiscount } from '@tabler/icons';
import Autocomplete from '@mui/material/Autocomplete';

const Filters = ({ options, optionLabel, inputChangeFn, renderInputFn }) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();
    const form = useForm();

    return (
        <Accordion sx={{ width: '96%', marginBottom: 2, borderRadius: 4, mr: 2, boxShadow: '0px 6px 16px rgba(0,0,0,0.15)' }}>
            <AccordionSummary
                expandIcon={<FilterAltIcon />}
                sx={{
                    flexDirection: 'row-reverse',
                    borderTop: 'none',
                    '& .MuiAccordionSummary-content': {
                        marginLeft: 1
                    },
                    '& .MuiAccordionSummary-content.Mui-expanded': {
                        marginLeft: 1
                    },
                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                        transform: 'none'
                    }
                }}
            >
                {t('Filters')}
            </AccordionSummary>
            <AccordionDetails>
                <FormProvider {...form}>
                    <Grid container spacing={2} padding={2}>
                        <Autocomplete
                            size="small"
                            disablePortal
                            options={options}
                            sx={{ width: '100%' }}
                            getOptionLabel={optionLabel}
                            onInputChange={inputChangeFn}
                            renderInput={renderInputFn}
                        />
                    </Grid>
                </FormProvider>
            </AccordionDetails>
        </Accordion>
    );
};

export default Filters;
